import { useState } from "react";
import {
  TextField,
  Card,
  Typography,
  Box,
  Paper,
  TableContainer,
  TableBody,
  TableRow,
  Table,
  TableCell,
  TableHead,
  Button,
} from "@mui/material";
import { styles } from "../theme/styles";
import { Creators } from "../store/ducks/users";
import { CustomButton } from "../components/CustomButton";
import { connect } from "react-redux";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import { useNavigate } from "react-router-dom";
import Cliploader from "./Cliploader";
import Swal from "sweetalert2";
import axios from "axios";
import "../index.css";

const PassForm = (props) => {
  const { userData } = props;
  const navigate = useNavigate();
  const [numeroOrden, setNumeroOrden] = useState("");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [ordenData, setOrdenData] = useState("");
  const [mostrarCardOrden, setMostrarCardOrden] = useState(false);
  const formattedDate = date.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const getInfoOrderSap = async (numeroOrden) => {
    try {
      const tiendaUsuario = userData.idNumber;
      if (!numeroOrden) {
        Swal.fire({
          title: "Ingresa una orden",
          icon: "info",
          iconColor: "#001F5B",
          confirmButtonColor: "#001F5B",
          confirmButtonText: "Aceptar",
        });
        return;
      }
      setLoading(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getInfoOrderSap`,
        { idOrder: numeroOrden, tiendaLogueada: tiendaUsuario },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );

      setOrdenData(data);
      setLoading(false);
      setMostrarCardOrden(true);
    } catch (error) {
      setLoading(false);
      console.log("Error", error);
      if (error) {
        if (error.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: error.response.data.error,
            confirmButtonColor: "#001F5B",
            confirmButtonText: "Aceptar",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Error al obtener información de la orden",
            confirmButtonColor: "#00205B",
            confirmButtonText: "Aceptar",
          });
        }
      }
    }
  };

  const closeInfoOrden = () => {
    setNumeroOrden("");
    setMostrarCardOrden(false);
  };
  return (
    <>
      <Cliploader loading={loading}></Cliploader>
      <Card sx={{}} style={styles.contenedorPassStyle2} variant="outlined">
        <div className="div-f">
          {mostrarCardOrden && (
            <span
              style={{ cursor: "pointer" }}
              onClick={closeInfoOrden}
              title="Cerrar Ventana">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-left">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M5 12l14 0" />
                <path d="M5 12l6 6" />
                <path d="M5 12l6 -6" />
              </svg>
            </span>
          )}
          <Typography
            variant="h6"
            justifyContent="center"
            color="#00205b"
            style={styles.title}>
            REPORTE DE RECEPCIÓN
          </Typography>
          {mostrarCardOrden && (
            <span
              style={{
                fontSize: "14px",
              }}>
              {formattedDate}
            </span>
          )}
        </div>
        {!mostrarCardOrden && (
          <span
            style={{
              fontSize: "14px",
            }}>
            {formattedDate}
          </span>
        )}

        {!mostrarCardOrden && (
          <div style={styles.container}>
            <div className="div-reporte-inicio">
              <p>Ingresa el número de orden</p>
              <form style={styles.form}>
                <TextField
                  onChange={(event) => {
                    const value = event.target.value;
                    const numericValue = value.replace(/\D/g, "");
                    setNumeroOrden(numericValue);
                  }}
                  value={numeroOrden}
                  style={styles.textField3}
                />
                {!loading ? (
                  <CustomButton
                    onClick={async (e) => {
                      e.preventDefault();
                      await getInfoOrderSap(numeroOrden);
                    }}
                    type="submit">
                    CONTINUAR
                  </CustomButton>
                ) : (
                  <></>
                )}
              </form>
            </div>
          </div>
        )}

        {mostrarCardOrden && (
          <div className="div-info-orden ">
            <h4>
              <b>
                Información de la Orden <b>{ordenData.cabecero.docCompras}</b>
              </b>
            </h4>
            <TableContainer
              sx={{
                marginBottom: "15px",
              }}>
              <Table size="small">
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <strong>No. Proveedor</strong>
                    </TableCell>
                    <TableCell>{ordenData.cabecero.idAcreedor}</TableCell>
                    <TableCell>
                      <strong>Proveedor</strong>
                    </TableCell>
                    <TableCell>{ordenData.cabecero.acreedor}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>
                      <strong>No. Tienda</strong>
                    </TableCell>
                    <TableCell>{ordenData.cabecero.idTienda}</TableCell>
                    <TableCell>
                      <strong>Tienda</strong>
                    </TableCell>
                    <TableCell>{ordenData.cabecero.tienda}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <strong>Cantidad Total</strong>
                    </TableCell>
                    <TableCell>{ordenData.cabecero.cantidadTotal}</TableCell>
                    <TableCell>
                      <strong>Costo Total</strong>
                    </TableCell>
                    <TableCell>{ordenData.cabecero.costoTotal}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <h4>
              <b>Detalle de la Orden</b>
            </h4>
            <TableContainer
              sx={{
                maxHeight: "200px",
                overflowX: "auto",
              }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>No. Material</TableCell>
                    <TableCell>Material</TableCell>
                    <TableCell>Cantidad</TableCell>
                    <TableCell>Costo Unitario</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ordenData.detalleOrden.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.idmMaterial}</TableCell>
                      <TableCell>{item.material}</TableCell>
                      <TableCell>{item.cantidad}</TableCell>
                      <TableCell>{item.costoUnitario}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <div className="div-center-btn">
              <CustomButton
                style={{
                  marginTop: "10px",
                  width: "150px",
                }}
                onClick={(e) => {
                  navigate(`/reporterecepcionForm/${numeroOrden}`);
                }}>
                Confirmar
              </CustomButton>
            </div>
          </div>
        )}
      </Card>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    menu: state.users.menu,
    userData: state.users.data,
    idNumber: state.users.idNumber,
    token: state.users.uid,
    loading: state.users.loading,
    message: state.config.message,
  };
};
const creators = {
  logout: Creators.logout,
  changePassword: Creators.changePassword,
  clearMessage: CreatorsConfig.clearMessage,
};
export default connect(mapStateToProps, creators)(PassForm);
